import { useAppDispatch } from "hooks/hooks";
import { ChangeEvent, useState } from "react";
import { getAllPayrollsForEmployee, setCalculatePayrollPopover } from "../payroll.slice";
import { useForm } from "react-hook-form";
import { hrService } from "Dashboard/scenes/HumanResources/services/hr.services";
import { ICalculatePayrollForEmployeeRequestParams } from "Dashboard/scenes/HumanResources/domain/ICalculatePayrollForEmployeeRequestParams";
import { GetLastYears } from "utils/dateUtils";
import { IEmployee } from "Dashboard/scenes/HumanResources/domain/IEmployee";
import { toast } from "react-toastify";
import MonthSelect from "Dashboard/components/MonthSelect";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesHr from "../../../popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";

interface IProps {
  employee: IEmployee;
}

function CalculatePayrollPopover({ employee }: IProps) {
  const dispatch = useAppDispatch();

  const [, setError] = useState(false);
  const [monthVal, setMonth] = useState(new Date().getMonth() + 1);

  const close = () => {
    dispatch(setCalculatePayrollPopover({ isOpen: false }));
    setMonth(new Date().getMonth() + 1);
  };

  const { handleSubmit, register } =
    useForm<ICalculatePayrollForEmployeeRequestParams>();

  const handleChangeMonth = (event: ChangeEvent<HTMLSelectElement>) => {
    setMonth(Number(event.target.value));
  };

  const onSubmit = async (data: ICalculatePayrollForEmployeeRequestParams) => {
    try {
      data = { ...data, month: monthVal }
      setError(false);
      await hrService.calculatePayrollForEmployee(data);
      toast.success("Obračun uspešno kreiran");
      dispatch(getAllPayrollsForEmployee(data.employeeId));
      close();
    } catch (error: any) {
      if (error.response.status === 400) {
        setError(true);
      }
    }
  };

  const years = GetLastYears(4);

  return (
    <form onSubmit={handleSubmit(onSubmit)}
      className={`
        ${classesHr.hrCalculate}
        ${classes.basicPopoverView}
        ${classes.gPopoverInputs}`}
    >
      <input
        type="hidden"
        value={employee?.employeeId}
        {...register("employeeId")}
      />
      <div>
        <div>
          <label>Mesec:</label>
          <MonthSelect classes={classes.dotField}
            onChange={handleChangeMonth} defaultValue={monthVal} />
        </div>
      </div>
      <div>
        <div>
          <label>Godina:</label>
          <select className={classes.dotField}
            {...register("year")}>
            {years.map((year, index) => (
              <option value={year} key={index}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className={classes.buttons}>
        <button className={classes.iconButton} type="submit">
          <FontAwesomeIcon
            icon={faLongArrowAltDown}
            className={classes.icon} />
        </button>
      </div>
    </form>
  );
}

export default CalculatePayrollPopover;
